import { gql } from '@apollo/client';

export const DELETE_CONTACT = gql`
  mutation DeleteContactMutation($id: String!) {
    DeleteContact(id: $id)
  }
`;

export const CREATE_CONTACT = gql`
  mutation CreateContact($request: CreateContactRequest!) {
    CreateContact(request: $request) {
      id
    }
  }
`;

export const CREATE_BULK_CONTACT = gql`
  mutation CreateBulkContact($request: [CreateContactRequest!]!) {
    CreateBulkContact(request: $request) {
      ... on PaginationResponse {
        count
      }
      ... on Contacts {
        data {
          id
          team {
            ... on Team {
              name
            }
          }
        }
      }
    }
  }
`;

export const EDIT_CONTACT = gql`
  mutation UpdateContact($id: String!, $request: UpdateContactRequest!) {
    UpdateContact(id: $id, request: $request) {
      id
    }
  }
`;
